module.exports = __webpack_public_path__ + "static/media/icon_playground_create.834b05b4.svg";